export interface IShipmentFormData {
  fulfillmentId :number;
  salesOrderId :number;
  shipmentId :string;
  warehouseGroupId :number;
  warehouseGroup :string;
  items :IShipmentItemFormData[];
  shipDate ?:string;
  carrierCode ?:string;
  trackingNumber ?:string;
  sscc ?:string;
  cost ?:number;
  status ?:string;
  weight :{
    units :string;
    value :number;
  };
  dimensions :{
    units :string;
    length :number;
    width :number;
    height :number;
  };
}

export interface IShipmentItemFormData {
  salesOrderItemId :number;
  orderItemId :number;
  lineItemId :number;
  productId :number;
  sku :string;
  productName :string;
  quantity :string;
  remainingQty :string;
  availableQty :string;
  fulfillmentOrderItemId :number;
}

export interface IManualShipmentPayload {
  salesOrderId :number | null;
  warehouseGroupId :number;
  shipmentId :string;
  fulfillmentOrderId :number | null;
  shipDate :string;
  carrierCode :string;
  trackingNumber :string;
  sscc :string;
  cost :string;
  status :string;
  weight :{
    units :string;
    value :number;
  };
  dimensions :{
    units :string;
    length :number;
    width :number;
    height :number;
  };
  items :{
    orderItemId :number;
    fulfillmentOrderItemId :number;
    salesOrderItemId :number;
    quantity :string;
  }[];
}

export enum EShipmentFormDataSource {
  SALES_ORDER = 'salesOrder',
  FULFILLMENT_ORDER = 'fulfillmentOrder',
  SHIPMENT = 'shipment',
}

export type TShipmentFormDataSource =
  | EShipmentFormDataSource.SALES_ORDER
  | EShipmentFormDataSource.FULFILLMENT_ORDER
  | EShipmentFormDataSource.SHIPMENT;

export interface IShipmentItem {
  id :number;
  createdAt :string;
  updatedAt :string;
  status :string;
  shipstationShipmentId :number;
  orderItemId :number;
  lineItemKey :string;
  sku :string;
  name :string;
  imageUrl :string | null;
  weight :string; // This appears to be a JSON string, not an object
  quantity :number;
  unitPrice :string;
  warehouseLocation :string | null;
  options :any; // Define a more specific type if available
  productId :number;
  fulfillmentSku :string | null;
}

export interface IShipment {
  id :number;
  createdAt :string;
  updatedAt :string;
  status :string;
  salesOrderId :number;
  shipmentId :string;
  orderId :string;
  orderKey :string;
  userId :string;
  orderNumber :string;
  createDate :string;
  shipDate :string;
  shipmentCost :number;
  insuranceCost :string;
  trackingNumber :string;
  isReturnLabel :boolean;
  batchNumber :string | null;
  carrierCode :string;
  serviceCode :string | null;
  packageCode :string | null;
  confirmation :string | null;
  warehouseId :number | null;
  voided :boolean;
  voidDate :string | null;
  marketplaceNotified :boolean;
  notifyErrorMessage :string | null;
  shipTo :{
    name :string;
    company :string;
    street1 :string;
    street2 :string | null;
    city :string;
    state :string;
    postalCode :string;
    country :string;
    phone :string;
    email :string;
  };
  weight :{
    value :number;
    units :string;
  };
  dimensions :{
    length :number;
    width :number;
    height :number;
    units :string;
  };
  insuranceOptions :any; // Define if structure is known
  advancedOptions :any; // Define if structure is known
  shipmentItems :IShipmentItem[];
  labelData :any;
  formData :any;
  salesOrderShipmentId :number;
  fulfillmentId :number | null;
  lumStatus :string;
  appIntegrationAccountId :number | null;
  fulfillmentOrderWarehouseGroup ?:string;
  salesOrderWarehouseGroup ?:string;
}
